import React from 'react'
import { connect } from 'react-redux'
import { Fade, Collapse } from '@material-ui/core'
import { Icon, Label } from 'semantic-ui-react'

import { StatusTag } from 'components'

import { 
  Container,
  THeader,
  TList,
  TListLine,
  TItemCont,
  TItemData
} from './styled'

const TrackingItem = props => {
  const {
    data,
    title,
    icon='',
    redirect=null,
    isLast=false,
    onCollapse=null,
    activeCollapse=true
  } = props

  return (
    <Container>
      <THeader>
        <Icon link circular inverted color='grey' name={icon||'minus'} onClick={()=>onCollapse?onCollapse():null}/>
        <span>{title}</span>
      </THeader>
      {data&&data.items&&data.items.length>0?
        <div>
            {data.items.map((x,i)=>{
              return(
                <TList>
                  <TListLine isLast={isLast}/>
                  <Collapse in={activeCollapse}>
                    <Fade in={true} timeout={1000}>
                      <TItemCont>
                        <div className='lineV1'>
                          {i>0?
                            <div className='lineV2'/>
                            :null
                          }
                        </div>
                        <div className='lineH'/>
                        <Label as='a' onClick={()=>window.open(redirect&&redirect(x.id),"_blank")}>
                          <TItemData>
                            <Icon name='file alternate' />
                            <div className='docNum'>{x.documentNumber}</div>
                            <StatusTag style={{alignSelf:'flex-end'}} status={x.status} statusName={x.statusName}/>
                          </TItemData>
                        </Label>
                      </TItemCont>
                    </Fade>
                  </Collapse>
                </TList>
              )
            })}
        </div>
        :
        <div>
          <TList>
            <TListLine isLast={isLast}/>
            <Collapse in={activeCollapse}>
              <Fade in={true} timeout={1000}>
                <TItemCont>
                  <div className='lineV1'/>
                  <div className='lineH'/>
                  <div className='labelNotFound'>Process not found</div>
                </TItemCont>
              </Fade>
            </Collapse>
          </TList>
        </div>
      }
    </Container>
  )
}

const mapStateToProps = state => {
  return {
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(TrackingItem)
